<template>
  <div id="app" :class="{'is-mobile': isPhone}">
    <Header />
    <!-- <img src="./assets/logo.png" /> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      isPhone: window.isPhone
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
  min-width: 1200px;
}
.pagew {
  width: 1200px;margin: auto;position: relative;
}
.banner-text-box {
  text-align: left;
  background: url('./assets/image/text-box.png') no-repeat;
  width: 778px;height: 363px;top: 380px;
  padding: 80px 80px 0;box-sizing: border-box;color: #fff;
  position: absolute;left: 50%;transform: translateX(-50%);
  transform-origin: center center;
}
.banner-text-box p {
  text-indent: 25px;line-height: 22px;margin-bottom: 20px;
}

/* @media screen and (max-width: 1580px) {
  .banner-text-box {
    transform: translateX(-50%) scale(.8);
    top: 180px;
  }
}
@media screen and (max-width: 1280px) {
  .banner-text-box {
    transform: translateX(-50%) scale(.65);
    top: 220px;
  }
} */
</style>



// WEBPACK FOOTER //
// src/App.vue